import { toast } from "react-toastify";

const toastError = (err) => {
  const errorMsg = err.response?.data?.message || err.message || "Ocorreu um erro inesperado";
  
  if (err.response?.status === 401) {
    toast.error("Sessão expirada. Faça login novamente.");
  } else if (err.response?.status === 403) {
    toast.error("Você não tem permissão para realizar esta ação.");
  } else if (err.response?.status === 404) {
    toast.error("Recurso não encontrado.");
  } else if (err.response?.status >= 500) {
    toast.error("Erro interno do servidor. Tente novamente mais tarde.");
  } else {
    toast.error(errorMsg);
  }
  
  console.error("Error details:", err);
};

export default toastError;